import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import kitiRechargeService from './kitiRechargeService';


export const getKitiRecharges = createAsyncThunk('admin/kiti-recharges', async (params, {rejectWithValue}) => {
    try {
        const response = await kitiRechargeService.getKitiRecharges(params);
        return response;
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return rejectWithValue(message);
    }
});

const initialState = {
    kitiRecharges: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message:''
};

export const kitiRechargeSlice = createSlice({
    name: 'adminKitiRecharges',
    initialState,
    reducers: {
        reset: (state) => {
            state.isError = false;
            state.isSuccess = false;
            state.isLoading = false;
            state.message = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getKitiRecharges.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getKitiRecharges.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.kitiRecharges = action.payload;
            })
            .addCase(getKitiRecharges.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
})

export const {reset} = kitiRechargeSlice.actions;
export default kitiRechargeSlice.reducer;